import React from 'react';

import DocumentsForm from 'buyside/components/presentation/Form/DocumentsForm/documentsForm';

// NOTE: make sure to update the appropriate schema in util/userProfileShowPageValidationSchemata

const ResearchForm = () => {
  return (
    <DocumentsForm
      title="Featured Research Documents"
      attr="userProfile.profileAttachments"
      withDescription
    />
  );
};

export default ResearchForm;
